import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import NotificationTypeServices from "./NotificationType.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getNotificationType = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_NOTIFICATION_TYPE,
      payload: true,
    });
    const resp = await NotificationTypeServices.getNotificationType(filters);
    dispatch({
      type: actions.GET_NOTIFICATION_TYPE,
      payload: {
        notificationTypes: resp.data.data,
        notificationTypesLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.NOTIFICATION_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_TYPE,
      payload: false,
    });
  }
};

export const getNotificationTypeById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_NOTIFICATION_TYPE,
      payload: true,
    });
    const resp = await NotificationTypeServices.getNotificationTypeByID(id);
    dispatch({
      type: actions.GET_NOTIFICATION_TYPE,
      payload: {
        notificationTypes: resp.data,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_TYPE_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.NOTIFICATION_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_TYPE,
      payload: false,
    });
  }
};

export const saveNotificationType =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATION_TYPE,
        payload: true,
      });
      const resp = await NotificationTypeServices.saveNotificationType(data);
      const { notificationTypes, notificationTypesLength } = getState().notificationsType;
      const _notificationTypes = [...notificationTypes, resp.data];
      dispatch({
        type: actions.GET_NOTIFICATION_TYPE,
        payload: {
          notificationTypes: _notificationTypes,
          notificationTypesLength: notificationTypesLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATION_TYPE,
        payload: false,
      });
    }
  };

export const editNotificationType =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_NOTIFICATION_TYPE,
        payload: true,
      });
      const resp = await NotificationTypeServices.editNotificationType(id, data);
      const { notificationTypes, notificationTypesLength } = getState().notificationsType;
      let _notificationTypes = [...notificationTypes]
      _notificationTypes[index] = resp.data;
      dispatch({
        type: actions.GET_NOTIFICATION_TYPE,
        payload: {
          notificationTypes: _notificationTypes,
          notificationTypesLength: notificationTypesLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_NOTIFICATION_TYPE,
        payload: false,
      });
    }
  };

export const deleteNotificationType = (id, index) => async (dispatch, getState) => {
  try {
   
    dispatch({
      type: actions.LOADING_NOTIFICATION_TYPE,
      payload: true,
    });
    await NotificationTypeServices.deleteNotificationType(id);
    const { notificationTypes, notificationTypesLength } = getState().notificationsType;
    let _notificationTypes = [...notificationTypes]
    _notificationTypes.splice(index, 1);
    dispatch({
      type: actions.GET_NOTIFICATION_TYPE,
      payload: {
        notificationTypes: _notificationTypes,
        notificationTypesLength: notificationTypesLength - 1,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_TYPE_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;                         
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.NOTIFICATION_TYPE_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_TYPE,
      payload: false,
    });
  }
};
